var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav-bar',{attrs:{"menuItems":_vm.menuItems,"portalButton":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }